<template>
    <div id="subscribe">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">我的订阅</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>
        <ul v-infinite-scroll="getSubscribeList">
            <li class="nav">
                <span>订阅书籍</span>
                <span>订阅方式</span>
                <span>订阅数量</span>
                <span>订阅金额</span>
            </li>

            <router-link v-for="val in booklist" class="list" tag="li" :to="{name:'Book',params:{wid: val.wid}}">
                <el-image :src="'http://static.yuread.cn/'+ val.h_cover + '@!thumb'" class="fl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
                <div v-if="val.type == 5">单本</div>
                <div v-if="val.type != 5">单章</div>
                <div>{{val.counts}}章</div>
                <router-link :to="{name:'Subscribelist',params:{wid : val.wid}}" tag="div">
                    <p class="tc">{{val.tMoney}}书币</p>
                    <p class="tc">{{val.tVoucher}}书豆</p>
                </router-link>
            </router-link>
        </ul>
    </div>


</template>

<script>
    export default {
        name: "Subscribe",
        data(){
            return {
                page : 1,
                booklist : [],
                last_page : 1
            }
        },methods:{
            getSubscribeList(){
                if(this.page > this.last_page){
                    return;
                }

                this.axios.post('/api/bill/getSubscribeList',{
                    page : this.page,
                }).then(r => {
                    this.page ++;
                    let data = r.data;
                    this.last_page = data.data.last_page;
                    if(data.code == 1){
                        data.data.data.forEach(v =>{
                            this.booklist.push(v);
                        })
                    }
                })
            }
        },created(){

        }
    }
</script>

<style lang="less">
    #subscribe{background: #f6f6f7;overflow: auto;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        ul{height: calc(100% - 100px);background: #fff;overflow: auto;
            .nav{display: flex;padding: 20px 0;border-bottom: 1px solid #efefef;
                span{flex: 1;text-align: center;font-size: 26px;color:#666;}
            }

            .list{display: flex;padding: 20px 0;border-bottom: 1px solid #efefef;
                >div{flex: 1;text-align: center;color:#666;font-size: 26px;padding-top: 50px;}
                .el-image{padding-top: 0;
                    img{width:108px;height:148px;}
                }
            }

        }
    }
</style>
